/**
 * Created by andrey on 01.09.17.
 */

cleverapps.Shaders = {
    GRAYSCALE_SPRITE_KEY: "grayscaleSprite",
    OUTLINE_KEY: "outline",
    OUTLINE_SPRITE_KEY: "outlineSprite",
    FLICKER_SHADER_KEY: "flicker",
    BLUR_FADE_KEY: "blur_fade",
    BLUR_CURTAIN_KEY: "blur_curtain",
    BLUR_CURTAIN_REVERSE_KEY: "blur_curtain_reverse",
    GLARE_KEY: "glare",

    VERTEX_SRC:
    "  attribute vec4 a_position; \n"
    + "attribute vec2 a_texCoord; \n"
    + "attribute vec4 a_color;  \n"

    + "varying lowp vec4 v_fragmentColor; \n"
    + "varying mediump vec2 v_texCoord; \n"

    + "void main() \n"
    + "{ \n"
    + "    gl_Position = CC_PMatrix * a_position;  \n"
    + "    v_fragmentColor = a_color; \n"
    + "    v_texCoord = a_texCoord; \n"
    + "}",

    // sprite vertices come in world coordinates, a band computed from them is the same on sliced and atlas sprites
    GLARE_VERTEX_SRC:
    "  attribute vec4 a_position; \n"
    + "attribute vec2 a_texCoord; \n"
    + "attribute vec4 a_color;  \n"

    + "varying lowp vec4 v_fragmentColor; \n"
    + "varying mediump vec2 v_texCoord; \n"
    + "varying vec2 v_position; \n"

    + "void main() \n"
    + "{ \n"
    + "    gl_Position = CC_PMatrix * a_position;  \n"
    + "    v_fragmentColor = a_color; \n"
    + "    v_texCoord = a_texCoord; \n"
    + "    v_position = a_position.xy; \n"
    + "}",

    // a slanted soft band lights only the sprite's own pixels, so it follows any shape
    GLARE_FRAGM:
        "varying vec4 v_fragmentColor;\n"
        + "varying vec2 v_texCoord;\n"
        + "varying vec2 v_position;\n"

        + "uniform vec2 u_center;\n"
        + "uniform float u_width;\n"
        + "uniform float u_slope;\n"
        + "uniform vec4 u_color;\n"

        + "void main()\n"
        + "{\n"
        + "    vec4 c = texture2D(CC_Texture0, v_texCoord);\n"
        + "    float d = v_position.x - u_center.x - (v_position.y - u_center.y) * u_slope;\n"
        + "    float band = 1.0 - smoothstep(0.0, u_width, abs(d));\n"
        // blends toward the color instead of adding it: added light clips on bright pixels, the band looked wider there
        + "    gl_FragColor = v_fragmentColor * vec4(mix(c.rgb, u_color.rgb * c.a, u_color.a * band), c.a);\n"
        + "}\n",

    GRAYSCALE_SRC:
        "varying vec2 v_texCoord;\n"
        + "varying vec4 v_fragmentColor; \n"
        + "void main()"
        + "{"
        + "   vec4 col = texture2D(CC_Texture0, v_texCoord);\n"
        + "   float gray = dot(col.rgb, vec3(0.25, 0.25, 0.25));\n"
        + "   vec3 mixed = mix(col.rgb, vec3(gray), 0.8);\n"
        + "   gl_FragColor = v_fragmentColor * vec4(mixed, col.a);\n"
        + "}\n",

    OUTLINE_SRC:
        "  varying vec2 v_texCoord;\n"
        + "void main()\n"
        + "{\n"
        + "     vec4 color  = texture2D(CC_Texture0, v_texCoord);\n"
        + "     vec4 transparent = vec4(0.0, 0.0, 0.0, 0.0);\n"
        + "     vec4 outlineColor = vec4(1, 0.96, 0.0, 1);\n"
        + "     gl_FragColor = color.a < 0.8  ? transparent : outlineColor;\n"
        + "}\n",

    OUTLINE_SPRITE_SRC:
        "  varying vec2 v_texCoord;\n"
        + "varying vec4 v_fragmentColor;\n"

        + "uniform vec2 u_step;\n"
        + "uniform vec4 u_color;\n"

        + "float edgeSample(vec2 dir)\n"
        + "{\n"
        + "     return smoothstep(0.5, 0.8, texture2D(CC_Texture0, v_texCoord + u_step * dir).a);\n"
        + "}\n"

        + "void main()\n"
        + "{\n"
        + "     float fill = texture2D(CC_Texture0, v_texCoord).a;\n"

        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(0.462, 0.191)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(0.462, -0.191)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(-0.462, 0.191)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(-0.462, -0.191)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(0.191, 0.462)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(0.191, -0.462)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(-0.191, 0.462)).a);\n"
        + "     fill = max(fill, texture2D(CC_Texture0, v_texCoord + u_step * vec2(-0.191, -0.462)).a);\n"

        // the coverage of the outer ring falls off gradually with the distance from the silhouette - this gradient fades the outline edge to transparent
        + "     float edge = edgeSample(vec2(1.0, 0.0));\n"
        + "     edge += edgeSample(vec2(0.924, 0.383));\n"
        + "     edge += edgeSample(vec2(0.707, 0.707));\n"
        + "     edge += edgeSample(vec2(0.383, 0.924));\n"
        + "     edge += edgeSample(vec2(0.0, 1.0));\n"
        + "     edge += edgeSample(vec2(-0.383, 0.924));\n"
        + "     edge += edgeSample(vec2(-0.707, 0.707));\n"
        + "     edge += edgeSample(vec2(-0.924, 0.383));\n"
        + "     edge += edgeSample(vec2(-1.0, 0.0));\n"
        + "     edge += edgeSample(vec2(-0.924, -0.383));\n"
        + "     edge += edgeSample(vec2(-0.707, -0.707));\n"
        + "     edge += edgeSample(vec2(-0.383, -0.924));\n"
        + "     edge += edgeSample(vec2(0.0, -1.0));\n"
        + "     edge += edgeSample(vec2(0.383, -0.924));\n"
        + "     edge += edgeSample(vec2(0.707, -0.707));\n"
        + "     edge += edgeSample(vec2(0.924, -0.383));\n"

        + "     float alpha = max(smoothstep(0.5, 0.8, fill), smoothstep(0.0, 0.35, edge / 16.0));\n"
        + "     gl_FragColor = v_fragmentColor * vec4(u_color.rgb, 1.0) * (u_color.a * alpha);\n"
        + "}\n",

    // lowp would lower texture coordinates too - samples from neighbour frames of an atlas on old PowerVR GPUs
    FLICKER_FRAGM:
        "precision mediump float;\n"
        + "varying vec4 v_fragmentColor; \n"
        + "varying vec2 v_texCoord; \n"

        + "uniform float sineTime; \n"
        + "uniform vec3 flickColor; \n"

        + "void main() \n"
        + "{ \n"
        + "    vec4 c = texture2D(CC_Texture0, v_texCoord); \n"
        + "    vec3 deltacolor = c.rgb * flickColor * sineTime;\n"
        + "    vec3 color = clamp(c.rgb + deltacolor, 0.0, 1.0);\n"
        + "    gl_FragColor = v_fragmentColor * vec4(color, c.a); \n"
        + "}",

    BLUR_TEMPLATE:
        "precision mediump float;\n"
        + "varying vec4 v_fragmentColor;\n"
        + "varying vec2 v_texCoord;\n"
        + "uniform float u_blurOffset;\n"
        + "uniform float u_extent;\n"
        + "uniform float u_blurStrength;\n"
        + "uniform float u_dim;\n"
        + "#define MAX_BLUR_WIDTH 4\n"
        + "#define INV_SQRT2 0.70710678\n"
        + "\n"
        + "bool skipPixel(float y)\n"
        + "{\n"
        + "    %{skipFunction}"
        + "}\n"
        + "\n"
        + "void main()\n"
        + "{\n"
        + "    vec4 center = texture2D(CC_Texture0, v_texCoord);\n"
        + "    if (skipPixel(v_texCoord.y)) { gl_FragColor = vec4(mix(center.rgb, vec3(0.0), u_dim), center.a); return; }\n"
        + "\n"
        + "    float blurWidth = u_blurStrength * float(MAX_BLUR_WIDTH);\n"
        + "    if (blurWidth <= 0.5) { gl_FragColor = vec4(mix(center.rgb, vec3(0.0), u_dim), center.a); return; }\n"
        + "\n"
        + "    vec2 offX = vec2(u_blurOffset, 0.0);\n"
        + "    vec2 offY = vec2(0.0, u_blurOffset);\n"
        + "    vec2 offD = vec2(u_blurOffset * INV_SQRT2, u_blurOffset * INV_SQRT2);\n"
        + "\n"
        + "    vec3 sumRGB = center.rgb;\n"
        + "    float sumA  = center.a;\n"
        + "    float sumW  = 1.0;\n"
        + "\n"
        + "    for (int i = 1; i <= MAX_BLUR_WIDTH; ++i) {\n"
        + "        if (float(i) > blurWidth) break;\n"
        + "        float w = 1.0 - float(i) / blurWidth;\n"
        + "        w = w * w * (3.0 - 2.0 * w);\n"
        + "\n"
        + "        vec2 dx = offX * float(i);\n"
        + "        vec2 dy = offY * float(i);\n"
        + "        vec2 dd = offD * float(i);\n"
        + "\n"
        + "        vec4 s1 = texture2D(CC_Texture0, v_texCoord + dx);\n"
        + "        vec4 s2 = texture2D(CC_Texture0, v_texCoord - dx);\n"
        + "        vec4 s3 = texture2D(CC_Texture0, v_texCoord + dy);\n"
        + "        vec4 s4 = texture2D(CC_Texture0, v_texCoord - dy);\n"
        + "        vec4 s5 = texture2D(CC_Texture0, v_texCoord + dd);\n"
        + "        vec4 s6 = texture2D(CC_Texture0, v_texCoord - dd);\n"
        + "        vec4 s7 = texture2D(CC_Texture0, v_texCoord + vec2(dd.x, -dd.y));\n"
        + "        vec4 s8 = texture2D(CC_Texture0, v_texCoord - vec2(dd.x, -dd.y));\n"
        + "\n"
        + "        sumRGB += (s1.rgb + s2.rgb + s3.rgb + s4.rgb + s5.rgb + s6.rgb + s7.rgb + s8.rgb) * w;\n"
        + "        sumA   += (s1.a   + s2.a   + s3.a   + s4.a   + s5.a   + s6.a   + s7.a   + s8.a  ) * w;\n"
        + "        sumW   += 8.0 * w;\n"
        + "    }\n"
        + "\n"
        + "    float outA  = sumA / sumW;\n"
        + "    vec3  outRGB = sumRGB / sumW; \n"
        + "    gl_FragColor = vec4(mix(outRGB, vec3(0.0), u_dim), outA);\n"
        + "}\n",

    BLUR_FADE_FRAGM: "",
    BLUR_CURTAIN_FRAGM: "",
    BLUR_CURTAIN_REVERSE_FRAGM: "",
    BLUR_FADE_SKIP: "   return false;\n",
    BLUR_CURTAIN_SKIP: "   return y > u_extent;\n",
    BLUR_CURTAIN_REVERSE_SKIP: "   return y < (1. - u_extent);\n",

    addProgram: function (key, vsh, fsh) {
        try {
            const program = new cc.GLProgram();
            program.initWithString(vsh, fsh);
            program.addAttribute(cc.ATTRIBUTE_NAME_POSITION, cc.VERTEX_ATTRIB_POSITION);
            program.addAttribute(cc.ATTRIBUTE_NAME_TEX_COORD, cc.VERTEX_ATTRIB_TEX_COORDS);
            program.addAttribute(cc.ATTRIBUTE_NAME_COLOR, cc.VERTEX_ATTRIB_COLOR);

            // a shader that fails to compile shows up only here - a broken program would make the sprite disappear
            if (!program.link()) {
                console.log(`shader ${key} failed to link`);
                return;
            }

            program.updateUniforms();
            cc.shaderCache.addProgram(program, key);
        } catch (e) {
            cleverapps.Shaders[key] = undefined;
            console.log(e);
        }
    },

    // cc.shaderCache.getProgram creates a broken default program for an unknown key
    getProgram: function (key) {
        return cc.shaderCache && cc.shaderCache._programs[key];
    },

    // compiled on first use, the loader scene runs before initialize
    getGlareProgram: function () {
        if (typeof gl === "undefined") {
            return undefined;
        }

        if (!this.getProgram(this.GLARE_KEY)) {
            this.addProgram(this.GLARE_KEY, this.GLARE_VERTEX_SRC, this.GLARE_FRAGM);
        }

        return this.getProgram(this.GLARE_KEY);
    },

    initialize: function () {
        if (typeof gl === "undefined") {
            return;
        }

        const addProgram = this.addProgram.bind(this);

        cleverapps.Shaders.initializing = true;

        addProgram(cleverapps.Shaders.GRAYSCALE_SPRITE_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.GRAYSCALE_SRC);
        addProgram(cleverapps.Shaders.OUTLINE_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.OUTLINE_SRC);
        addProgram(cleverapps.Shaders.OUTLINE_SPRITE_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.OUTLINE_SPRITE_SRC);
        addProgram(cleverapps.Shaders.FLICKER_SHADER_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.FLICKER_FRAGM);

        cleverapps.Shaders.BLUR_FADE_FRAGM = cleverapps.Shaders.BLUR_TEMPLATE.replace("%{skipFunction}", cleverapps.Shaders.BLUR_FADE_SKIP);
        cleverapps.Shaders.BLUR_CURTAIN_FRAGM = cleverapps.Shaders.BLUR_TEMPLATE.replace("%{skipFunction}", cleverapps.Shaders.BLUR_CURTAIN_SKIP);
        cleverapps.Shaders.BLUR_CURTAIN_REVERSE_FRAGM = cleverapps.Shaders.BLUR_TEMPLATE.replace("%{skipFunction}", cleverapps.Shaders.BLUR_CURTAIN_REVERSE_SKIP);

        addProgram(cleverapps.Shaders.BLUR_FADE_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.BLUR_FADE_FRAGM);
        addProgram(cleverapps.Shaders.BLUR_CURTAIN_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.BLUR_CURTAIN_FRAGM);
        addProgram(cleverapps.Shaders.BLUR_CURTAIN_REVERSE_KEY, cleverapps.Shaders.VERTEX_SRC, cleverapps.Shaders.BLUR_CURTAIN_REVERSE_FRAGM);

        cleverapps.Shaders.initializing = false;
    }
};
